import React from 'react';
import { Col, Fill, Row } from '../../components/RowCol';
import { Team } from './Game';
import logo from '../../images/jeopardy.png';
import Spacer from '../../components/Spacer';
import Scoreboard from './Scoreboard';
import styles from '../../style';
import Button from '../../components/Button';
import { getLocalState, setLocalState } from '../../localState';

type Props = {
	categoryCount: number;
	questionCount: number;
	finalJeopardyCategory: string | null;
	scores: Record<Team, number>;
	children: React.ReactNode;
};

class GameLayout extends React.Component<Props> {
	render() {
		const {
			categoryCount,
			questionCount,
			finalJeopardyCategory,
			children,
			scores,
		} = this.props;

		const { zoom } = getLocalState();

		const minWidth = 814;
		const width = Math.max(minWidth, (categoryCount * 206) - 10);
		const height = (questionCount * 120) + 109;

		return (
			<Fill style={{
				zoom,
			}}>
				<Row
					style={{
						position: 'fixed',
						right: 0,
						top: 0,
						color: 'white',
						padding: '10px',
					}}
					className="invisible-except-hover"
				>
					<Button
						label="Zoom In"
						onClick={() => {
							setLocalState('zoom', zoom + 0.1);
							this.forceUpdate();
						}}
					/>
					<Spacer horizontal={10} />
					<Button
						label="Zoom Out"
						onClick={() => {
							setLocalState('zoom', zoom - 0.1);
							this.forceUpdate();
						}}
					/>
				</Row>
				<Row fill center>
					<Col style={{
						width: `${width}px`,
						minWidth: `${width}px`,
					}}>
						<Col style={{
							height: `${height}px`,
							position: 'relative',
						}}>
							{children}
						</Col>
					</Col>

					<Spacer horizontal={100} />

					<Col style={{
						width: '700px',
						height: '450px',
						justifyContent: 'space-between',
					}}>
						<Row center style={{
							height: '200px',
						}}>
							{finalJeopardyCategory ? (
								<div style={{
									paddingLeft: '50px',
									paddingRight: '50px',
									textAlign: 'center',
									fontFamily: styles.questionFont,
									fontSize: styles.questionFontSize,
									textTransform: 'uppercase',
									textShadow: styles.shadow4,
									color: styles.questionColor,
								}}>
									{finalJeopardyCategory}
								</div>
							) : (
								<img
									alt="Jeopardy!"
									src={logo}
									style={{
										height: '150px',
									}}
								/>
							)}
						</Row>
						<Scoreboard
							scores={scores}
						/>
					</Col>
				</Row>
			</Fill>
		);
	}
}

export default GameLayout;
